<template>
  <v-dialog :value="dialog" max-width="500" persistent>
    <v-card>
      <v-form v-on:submit.prevent="confirm">
        <v-card-title>
          <span class="headline">{{ reset ? "Blanquear contraseña" : "Crear acceso" }}</span>
        </v-card-title>

        <v-card-text>
          <p class="mb-2 text-left">
            Usuario: <b>{{ reset && legajo.access ? legajo.access.email : legajo.email }}</b>
          </p>
          <p class="mb-0 text-left">
            Ingrese una contraseña temporal y pásesela al empleado. En el primer ingreso el sistema le pide cambiarla, así
            solo él la conoce.
          </p>

          <div class="row">
            <div class="col-md-12">
              <v-text-field v-model="password" label="Contraseña temporal*" name="password" data-vv-as="contraseña"
                v-validate="{ required: true, min: 8, regex: /^(?=.*[A-Za-z])(?=.*[0-9]).+$/ }" :type="show ? 'text' : 'password'"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show"
                hint="Al menos 8 caracteres, con letras y números"></v-text-field>
              <span class="red--text">{{ errors.first("password") }}</span>
              <div class="text-left">
                <v-btn small text color="primary" class="px-0" @click="generate">Generar contraseña</v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">{{ reset ? "Guardar" : "Crear acceso" }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { legajoService } from "@/libs/ws/legajoService";

const PASSWORD_CHARS = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
const PASSWORD_DIGITS = "23456789";

export default {
  props: {
    dialog: Boolean,
    legajo: Object,
    // true: nueva contraseña temporal para un acceso existente
    reset: Boolean,
  },
  data() {
    return {
      password: "",
      show: false,
      loading: false,
    };
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.password = "";
      this.show = false;
      this.$validator.reset();
    },
  },
  methods: {
    // 8 letras y 2 numeros, sin caracteres que se confundan (l, 1, O, 0)
    generate() {
      const pick = (chars) => chars.charAt(Math.floor(Math.random() * chars.length));
      let password = "";
      for (let i = 0; i < 8; i++) password += pick(PASSWORD_CHARS);
      password += pick(PASSWORD_DIGITS) + pick(PASSWORD_DIGITS);
      this.password = password;
      this.show = true;
    },
    close() {
      this.$emit("updateDialog", false);
    },
    async confirm() {
      if (this.loading || !(await this.$validator.validate())) return;

      this.loading = true;
      (this.reset ? legajoService.reset_access_password : legajoService.create_access)({ id: this.legajo.id, password: this.password })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("saved", response.result);
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al guardar el acceso.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
